import { FC } from "react";
import { Box, Button, Flex, ModalFooter } from "@chakra-ui/react";
import LoadingButton from "../../atom/Button/LoadingButton/LoadingButton";

interface ModalFooterComponentProps {
  setIsAlertOpen: (isOpen: boolean) => void;
  setIsOpen: (isOpen: boolean) => void;
  buttonTitle: string;
  deleteButtonName?: string;
  deleteEnabled: boolean;
  isLoaded?: boolean;
}

const ModalFooterComponent: FC<ModalFooterComponentProps> = ({
  setIsAlertOpen,
  setIsOpen,
  buttonTitle,
  deleteButtonName = "Eliminar item",
  deleteEnabled = true,
  isLoaded = true,
}) => {
  return (
    <ModalFooter justifyContent="flex-end" px="0">
      {deleteEnabled && !buttonTitle.includes("Criar") && (
        <Box>
          <LoadingButton
            variant="secondary"
            colorScheme="red"
            onClick={() => setIsAlertOpen(true)}
            isLoading={!isLoaded}
          >
            {deleteButtonName}
          </LoadingButton>
        </Box>
      )}

      <Flex gap={3} justifyContent="flex-end" alignItems="center" width="100%">
        <Button
          variant="tertiary"
          onClick={() => setIsOpen(false)}
          isDisabled={!isLoaded}
        >
          Cancelar
        </Button>
        <LoadingButton
          type="submit"
          variant="primary"
          colorScheme="green"
          isLoading={!isLoaded}
        >
          {buttonTitle}
        </LoadingButton>
      </Flex>
    </ModalFooter>
  );
};

export default ModalFooterComponent;
